import React from 'react';
import PropTypes from 'prop-types';
import AdminBadge from './assets/newOnlyCM.png';
import NewBadge from './assets/Badge-NewGame.png';
import './GameCardIcon.css';

export const GAME_BADGES = {
  new: NewBadge,
  admin: AdminBadge
};

function GameCardIcon({ game, alt, badge }) {
  const badgeTagCover = badge && GAME_BADGES[badge];
  const gameCover = game && game.gameDesktopCover;

  return (
    <div className="game-card-icon">
      {badgeTagCover && (
        <img
          className="game-card-icon-badge"
          src={badgeTagCover}
          alt={badge}
          draggable="false"
        />
      )}
      {gameCover && (
        <img
          className="game-card-icon-img"
          src={gameCover}
          alt={alt}
          draggable="false"
        />
      )}
      {!gameCover && (
        <div className="game-card-icon-default">
          <div>{alt}</div>
        </div>
      )}
    </div>
  );
}

GameCardIcon.propTypes = {
  game: PropTypes.object,
  alt: PropTypes.string,
  badge: PropTypes.string
};

export default GameCardIcon;
